import { UserResource } from '@rallycry/api-suite-typescript'
import { UserAccountResource } from '@rallycry/api-suite-typescript/dist/models/UserAccountResource'
import { RcTrans } from '@/components/atoms/RcTrans'
import { useCommunity } from '@/entity/community/useCommunity'
import { useCommunityPlaceholders } from '@/entity/community/useCommunityPlaceholders'
import { ChildDetailsForm } from '@/flows/Site/CreateDependentFlow/DependentDetailsForm'

export const CommunityPlaceholderCreateEdit = ({
  onComplete,
  existing
}: {
  onComplete: (user: UserResource, communityId: number) => Promise<void>
  existing?: UserAccountResource
}) => {
  const { community } = useCommunity()
  const { createPlaceholder, updatePlaceholder } = useCommunityPlaceholders()

  return (
    <ChildDetailsForm
      title={
        existing ? (
          <RcTrans i18nKey={'community:placeholders.edit-title'} />
        ) : (
          <RcTrans i18nKey={'community:placeholders.create-title'} />
        )
      }
      existing={existing}
      communityId={community?.id}
      onComplete={onComplete}
      onCreate={(communityId, cmd) =>
        existing?.id
          ? updatePlaceholder(existing.id, cmd.account)
          : createPlaceholder(communityId, cmd)
      }
    />
  )
}
